const features = [
  {
    icon: 'ri-shield-check-line',
    title: '完全免费',
    desc: '向日葵视频所有影视资源均免费在线观看，无需注册登录，无需付费会员，打开即看，真正零门槛观影体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速播放',
    desc: '多线路智能切换，全网CDN加速，高清视频秒加载，播放流畅不缓冲，任何网络环境均可稳定观看。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '支持1080P与4K超清画质，榴莲视频、红杏视频热播大片尽享影院级视觉体验，细节一览无余。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '电脑、平板、手机全终端完美适配，无需下载APP即可随时随地追剧观影，进度自动同步。',
  },
  {
    icon: 'ri-refresh-line',
    title: '海量片库',
    desc: '涵盖电影、电视剧、综艺、动漫全品类，每日同步更新热播剧集，向日葵视频片库持续扩充中。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            特色优势
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            向日葵视频持续优化播放体验，让每一位用户都能享受流畅高清的在线观影
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all duration-300 hover:translate-y-[-2px]"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100/80 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-900 font-heading">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}